<template>
  <v-skeleton-loader
    :class="classList"
    :loading="loading"
    :transition="transition"
    :type="type"
    :types="types"
    v-bind="$attrs"
  >
    <slot></slot>
  </v-skeleton-loader>
</template>

<script>
export default {
  name: 'GGLoading',
  inject: ['theme'],
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: false
    },
    transition: {
      type: String,
      default: 'fade-transition'
    },
    type: {
      type: String,
      default: 'card'
    },
    classList: {
      type: Array,
      default: () => ([])
    },
    types: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style scoped>

</style>
